import { OrderServiceTypeEnum, OrderTypeEnum } from '@admin/schema';

type OrderEvent = {
  category: string;
  eventName: string;
  timestamp: string;
};

type ShowOrder = {
  type: OrderTypeEnum;
  serviceType?: OrderServiceTypeEnum | null;
  address: {
    addressableType?: string | null;
  };
};

export const isWarehouseOrder = (order: ShowOrder) =>
  order.address.addressableType === 'Warehouse' &&
  order.type !== OrderTypeEnum.Restock &&
  order.serviceType !== OrderServiceTypeEnum.DropOff;

export const getCustomerNames = (customers: { name: string }[]) =>
  [...customers]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((customer) => customer.name)
    .join(', ');

export const getLastOrderEvent = (events: OrderEvent[]) => {
  const lastLinearOrderEvent = events
    .filter((event) => event.eventName !== 'clockin' && event.eventName !== 'clockout')
    .sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1))
    .find((event) => event.category === 'linear_orders');

  return lastLinearOrderEvent ? lastLinearOrderEvent.eventName.replace('_', ' ').toUpperCase() : '';
};
